export default __webpack_public_path__ + "static/media/dice_inactive.9ee353a6.svg";